import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Demo.scss";
import CalendlyEmbed from "../components/CalendlyEmbed";

const CALENDLY_URL = "https://calendly.com/skilldingkevin/podsy-1st-meeting";
const WALKTHROUGH_SHARE_URL = "https://www.loom.com/share/09efee8a4fe2462ba6fd550ef05e94c2";
const WALKTHROUGH_EMBED_URL = "https://www.loom.com/embed/09efee8a4fe2462ba6fd550ef05e94c2";

const PodsyMark = () => (
    <svg width="52" height="32" viewBox="0 0 160 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="4" y="4" width="152" height="92" rx="14" fill="#f7f7f5" />
        <circle cx="58" cy="50" r="17" stroke="#0a0f14" strokeWidth="7" />
        <circle cx="108" cy="50" r="12" fill="#e67700" />
        <circle cx="108" cy="50" r="2.2" fill="#0a0f14" />
        <circle cx="58" cy="50" r="3.4" fill="#e67700" />
    </svg>
);

const WalkthroughModal = ({ open, onClose }) => {
    useEffect(() => {
        if (!open) return undefined;

        const handleKeyDown = (evt) => {
            if (evt.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="mkt-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Walkthrough video"
            onClick={(evt) => { if (evt.target === evt.currentTarget) onClose(); }}
        >
            <div className="mkt-modal__inner">
                <button type="button" className="mkt-modal__close" aria-label="Close video" onClick={onClose}>
                    &times;
                </button>
                <div className="mkt-modal__frame">
                    <iframe
                        className="mkt-modal__iframe"
                        src={WALKTHROUGH_EMBED_URL}
                        title="Podsy walkthrough"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    );
};

const Demo = () => {
    const [videoOpen, setVideoOpen] = useState(false);

    return (
        <div className="lead-page mkt-page">
            <div className="mkt-ambient-glow" aria-hidden="true" />

            <header className="mkt-header">
                <Link to="/" className="mkt-header__brand">
                    <PodsyMark />
                    Podsy
                </Link>
            </header>

            <main className="mkt-main mkt-main--demo">
                <h1 className="mkt-h1">See a Podcast Club</h1>
                <p className="mkt-lede">
                    Two ways to do this: watch a walkthrough of one already built, or
                    build yours right now.
                </p>

                <div className="mkt-option-grid">
                    <div className="mkt-card mkt-option-card">
                        <p className="mkt-eyebrow">Option A</p>
                        <h2 className="mkt-h2">Watch a walkthrough</h2>
                        <p className="mkt-option-card__text">
                            A short video walking through a real Podcast Club, built from a real
                            show's episodes, so you can see exactly what one looks like.
                        </p>
                        <a
                            href={WALKTHROUGH_SHARE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mkt-btn"
                            onClick={(evt) => { evt.preventDefault(); setVideoOpen(true); }}
                        >
                            Watch the video
                        </a>
                    </div>

                    <div className="mkt-card mkt-option-card">
                        <p className="mkt-eyebrow">Option B</p>
                        <h2 className="mkt-h2">Build your own</h2>
                        <p className="mkt-option-card__text">
                            Add your RSS feed and build a working Club from your own episodes,
                            takes about fifteen minutes, start to finish.
                        </p>
                        <Link to="/build" className="mkt-btn">Build my Club</Link>
                        <p className="mkt-option-card__footnote">
                            Don't know your RSS feed?{" "}
                            <a href="https://rss.com/tools/find-my-feed/" target="_blank" rel="noopener noreferrer">
                                Find it here
                            </a>.
                        </p>
                    </div>
                </div>

                <section className="mkt-ready">
                    <h2 className="mkt-h2 mkt-h2--center">Ready to talk?</h2>
                    <p className="mkt-lede mkt-lede--sm">
                        If you've seen enough already, you don't have to wait until you've
                        built anything.
                    </p>

                    <div className="mkt-only-dont">
                        <div>
                            <h3 className="mkt-h3">Only book if</h3>
                            <p>
                                You have at least 20 episodes and you have a good reason why it
                                would be useful to know who your listeners are.
                            </p>
                        </div>
                        <div>
                            <h3 className="mkt-h3">Don't book if</h3>
                            <p>
                                You launched last month, you're looking for help growing
                                downloads, or you're happy with the show exactly as it is. All
                                three are fine answers. This just isn't the thing for them.
                            </p>
                        </div>
                    </div>

                    <CalendlyEmbed url={CALENDLY_URL} />
                </section>
            </main>

            <WalkthroughModal open={videoOpen} onClose={() => setVideoOpen(false)} />
        </div>
    );
};

export default Demo;
